export interface Resources {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  original_name: string;
  description: string;
  file: string;
  type: string;
  link: string;
}

export interface ResourceUpload {
  name: string;
  original_name?: string;
  description?: string;
  file?: File;
  link?: string;
}

export enum ResourceType {
  Pdf = "Pdf",
  YTVideo = "YT-Video",
}

export interface ResourceFiltersInterface {
  orderDir: string;
  orderBy: string;
}
